module.exports = __webpack_public_path__ + "static/mabry-medium-pro-3cdb9c0c2fedadfc886a3bb838bce776.woff2";